import { useCallback, useState } from 'react';

import type { HorizontalTab } from '@/lib/base/tabs';
import { HorizontalTabs } from '@/lib/base/tabs';

import { TimelineSection } from '../sections/timeline-section';

// Comments is deliberately absent for now — it shipped as a disabled
// placeholder ({ id: 'comments', label: 'Comments', disabled: true }) but is
// hidden until the feature exists. Re-add the entry here (before 'activity')
// when comments land. The Activity tab itself stays visible as the section's
// heading (product call) — hence `showSingleTab` on the bar below.
const TASK_TABS: HorizontalTab[] = [{ id: 'activity', label: 'Activity' }];

interface TaskTabsSectionProps {
  /** The task's entity id — the timeline subject. */
  entityId: string;
  entityType: 'ahoy_task';
  orgId: number;
}

export function TaskTabsSection({
  entityId,
  entityType,
  orgId,
}: TaskTabsSectionProps) {
  const [activeTab, setActiveTab] = useState('activity');
  const handleTabChange = useCallback((tabId: string) => {
    setActiveTab(tabId);
  }, []);

  return (
    <div className='flex flex-col gap-2'>
      <HorizontalTabs
        tabs={TASK_TABS}
        activeTab={activeTab}
        onTabChange={handleTabChange}
        idPrefix='task-tabs'
        lazyPanels
        showSingleTab
      />
      {activeTab === 'activity' && (
        <div
          role='tabpanel'
          id='task-tabs-panel-activity'
          aria-labelledby='task-tabs-activity'
        >
          <TimelineSection
            entityId={entityId}
            orgId={String(orgId)}
            entityType={entityType}
            chromeless
            emptyMessage='No activity yet'
          />
        </div>
      )}
    </div>
  );
}
